import { render, staticRenderFns } from "./MultiImage.vue?vue&type=template&id=4777cedb&scoped=true&"
import script from "./MultiImage.vue?vue&type=script&lang=js&"
export * from "./MultiImage.vue?vue&type=script&lang=js&"
import style0 from "./MultiImage.vue?vue&type=style&index=0&id=4777cedb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777cedb",
  null
  
)

export default component.exports